import { render, staticRenderFns } from "./ExportExcel.vue?vue&type=template&id=52fbef63&scoped=true&"
import script from "./ExportExcel.vue?vue&type=script&lang=js&"
export * from "./ExportExcel.vue?vue&type=script&lang=js&"
import style0 from "./ExportExcel.vue?vue&type=style&index=0&id=52fbef63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbef63",
  null
  
)

export default component.exports